import { Navigate } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'

import { PlatformPermission } from '@/domain/permissions/rbac'
import { usePermissions } from '@/domain/permissions/usePermissions'

export const APP_ROLE_CLAIM = 'https://carringtonlabs.io/appRole'

// Extracted from AppRoutes so the guard can be exercised on its own, without
// pulling every page (and its data layer) into the test.
export const PermissionRoute = ({
  permission,
  children,
}: {
  permission: PlatformPermission
  children: React.ReactNode
}) => {
  const { user } = useAuth0()
  const { hasPermission } = usePermissions(user?.[APP_ROLE_CLAIM])

  if (!hasPermission(permission)) {
    return <Navigate to="/app" replace />
  }

  return <>{children}</>
}
